import { getMediaUrl } from "../helpers/DetailsHelpers";
import { Image, Pressable } from "react-native";
import { FlatList } from "react-native-gesture-handler";

export const ContentDetailsGallery = ({ content, navigation, t, findifyDataContext, ...props }: any) => {
    const images = (content?.galleries ?? [])
        .map((gallery: any) => {
            return getMediaUrl(gallery?.image_media ?? gallery?.media ?? gallery);
        })
        .filter(Boolean);

    return <FlatList
        key={'gallery_cols_3'}
        data={images}
        numColumns={3}
        columnWrapperStyle={{ marginTop: 0 }}
        contentContainerStyle={{ marginTop: 30 }}
        renderItem={({ item, index }) => {
            return <Pressable
                onPress={() => {
                    if (props.onImagePress) {
                        props.onImagePress(images, index);
                        return;
                    }
                    navigation.push('GallerySlidePage', {
                        images: images,
                        currentImage: index,
                    });
                }}
                style={{
                    flex: 1 / 3,
                    margin: 3,
                }}
            >
                <Image
                    style={{
                        aspectRatio: 1,
                        width: '100%',
                        objectFit: 'cover',
                        borderRadius: 10,
                        backgroundColor: 'pink'
                    }}
                    source={{ uri: item }} key={index} />
            </Pressable>;
        }}
    />
}
